// 单位建筑的接口写在这里
import request from '@/utils/request'
import data from '@/views/pdf/content'
// 消防系统信息  /cust/fireSys   GET  buildId:建筑ID
export function fireSys(buildId) {
  return request({
    url: '/api/cust/fireSys',
    method: 'GET',
    params: {
      buildId
    }

  })
}

// /cust/fireSysNew?buildId=1428
export function custFireSysNew(buildId) {
  return request({
    url: '/api/cust/fireSysNew',
    method: 'GET',
    params: {
      buildId
    }
  })
}
export function custFindAllFire() {
  return request({
    url: '/api/cust/findAllFire',
    method: 'GET'
    // params
    // headers: {
    //   AuthorIzation: token
    // }
  })
}
// 查询建筑信息 GET   /cust/buildInfo  custId：单位ID
export function buildInfo({
  token,
  ...params
}) {
  return request({
    url: '/api/cust/buildInfo',
    method: 'GET',
    params
  })
}

// 51  /cust/insertFireGun  添加消防水炮  POST   buildingId  建筑id
export function insertFireGun(token, buildingId) {
  return request({
    url: '/api/cust/insertFireGun?buildingId=' + buildingId,
    method: 'POST'
  })
}

// /cust/insertAutoMaic  添加消自动灭火系统  56   POST
export function insertAutoMaic(token, data) {
  return request({
    url: '/api/cust/insertAutoMaic',
    method: 'POST',
    data
  })
}
// 删除自动灭火系统   DELETE   /cust/deleteAutoMaic  id 系统id
export function deleteAutoMaic(token, id) {
  return request({
    url: '/api/cust/deleteAutoMaic?id=' + id,
    method: 'DELETE'
  })
}

// /cust/deleteFireAlarm  删除消防报警  DELETE  id 系统id
// 原来的接口/cust/insertProduct，将其替换为 /cust/insertProductNew，删除参数FORM_ID，额外传递两个参数，一个是建筑id，另一个是具体消防系统的code，其它保持不变
export function insertProduct(data) {
  return request({
    url: '/api/cust/insertProductNew',
    method: 'POST',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 原来的接口为 /cust/insertFireMsg (将接口替换为 /cust/insertFireMsgNew,不在传消防设施(equCode)这个参数这个参数，其它保持不变)
export function insertFireMsg(data) {
  return request({
    url: '/api/cust/insertFireMsgNew',
    method: 'POST',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 原来的接口为 /cust/updateCustFireMes(将接口替换为 /cust/updateCustFireMesNew,不在传消防设施(equCode)这个参数这个参数，其它保持不变)
export function updateCustFireMes(data) {
  return request({
    url: '/api/cust/updateCustFireMesNew',
    method: 'PUT',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 解除单位与建筑的关联  Put /cust/delBuildByCustId  String buildingId 建筑id
export function delBuildByCustId(token, buildingId) {
  return request({
    url: '/api/cust/delBuildByCustId',
    method: 'PUT',
    data: {
      buildingId
    },
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 查询所有的药剂种类 GET  /cust/findALlDrugs
export function findALlDrugs(token) {
  return request({
    url: '/api/cust/findALlDrugs',
    method: 'GET'
  })
}
// 查询所有的系统形式 GET /cust/findAllSysGas
export function findAllSysGas(token) {
  return request({
    url: '/api/cust/findAllSysGas',
    method: 'GET'
  })
}
// 查询所有的安全标识牌 GET  /cust/findAllSafeSign
export function findAllSafeSign(token) {
  return request({
    url: '/api/cust/findAllSafeSign',
    method: 'GET'
  })
}
// 查询所有的启动类型 GET /cust/findAllStartType
export function findAllStartType(token) {
  return request({
    url: '/api/cust/findAllStartType',
    method: 'GET'
  })
}

// 更新气体灭火系统信息 PUT  /cust/updateGasFireByBuildingId
export function updateGasFireByBuildingId(token) {
  return request({
    url: '/api/cust/updateGasFireByBuildingId',
    method: 'GET'
  })
}
// 添加气体灭火 POST  /cust/insertGasFiredata
export function insertGasFire(token, data) {
  return request({
    url: '/api/cust/insertGasFire',
    method: 'POST',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 添加消防报警系统 POST  /cust/insertFireAlarm
export function insertFireAlarm(token, data) {
  return request({
    url: '/api/cust/insertFireAlarm',
    method: 'POST',
    data
  })
}

// 添加室外消防给水系统 POST /cust/insertFireWaterOut

export function insertFireWaterOut(token, data) {
  return request({
    url: '/api/cust/insertFireWaterOut',
    method: 'POST',
    data
  })
}

// 添加室内消火栓系统 POST  /cust/insertFireWaterIn
export function insertFireWaterIn(token, data) {
  return request({
    url: '/api/cust/insertFireWaterIn',
    method: 'POST',
    data
  })
}

// 添加消防安全疏散系统 POST  /cust/insertFireSafe
export function insertFireSafe(token, data) {
  return request({
    url: '/api/cust/insertFireSafe',
    method: 'POST',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 添加灭火器登记表 POST /cust/insertExtingusher

export function insertExtingusher(token, data) {
  return request({
    url: '/api/cust/insertExtingusher',
    method: 'POST',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 添加防排烟系统 POST /cust/insertSmoke
export function insertSmoke(token, data) {
  return request({
    url: '/api/cust/insertSmoke',
    method: 'POST',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}

// =============================删除报警系统
// 删除气体灭火 DELETE  /cust/deleteGasFire
export function deleteGasFire(token, data) {
  return request({
    url: '/api/cust/deleteGasFire?id=' + data,
    method: 'DELETE'
  })
}
// 删除消防水炮  DELETE  /cust/deleteFireGun  id 系统id
export function deleteFireGun(token, data) {
  return request({
    url: '/api/cust/deleteFireGun?id=' + data,
    method: 'DELETE'
  })
}

// 删除消防报警 DELETE  /cust/deleteFireAlarm
export function deleteFireAlarm(token, id) {
  return request({
    url: '/api/cust/deleteFireAlarm?id=' + id,
    method: 'DELETE',
    data: {
      id
    }
  })
}

// 删除室外消防给水系统    DETELE  /cust/deleteFireWaterOut
export function deleteFireWaterOut(token, data) {
  return request({
    url: '/api/cust/deleteFireWaterOut?id=' + data,
    method: 'DELETE'
  })
}

// 删除室内消火栓系统  DELETE   /cust/deleteFireWaterIn
export function deleteFireWaterIn(token, data) {
  return request({
    url: '/api/cust/deleteFireWaterIn?id=' + data,
    method: 'DELETE'
  })
}
// 删除消防安全疏散系统  DELETE /cust/deleteFireSafe
export function deleteFireSafe(token, data) {
  return request({
    url: '/api/cust/deleteFireSafe?id=' + data,
    method: 'DELETE'
  })
}
// 删除灭火器登记  DELETE  /cust/deleteExtingusher
export function deleteExtingusher(token, data) {
  return request({
    url: '/api/cust/deleteFireSafe?id=' + data,
    method: 'DELETE'
  })
}
// 删除防排烟系统 DELETE  /cust/deleteSmoke
export function deleteSmoke(token, data) {
  return request({
    url: '/api/cust/deleteSmoke?id=' + data,
    method: 'DELETE'
  })
}

// 修改消防系统

// 更新室内消火栓系统  PUT  /cust/updateFireWaterIn
export function updateFireWaterIn(token, data) {
  return request({
    url: '/api/cust/updateFireWaterIn',
    method: 'PUT',
    data
  })
}
// 更新消防安全疏散系统  PUT /cust/updateFireSafe
export function updateFireSafe(token, data) {
  return request({
    url: '/api/cust/updateFireSafe',
    method: 'PUT',
    data,
    headers: {
      AuthorIzation: token,
      'content-type': 'application/json'
    }
  })
}

// 更新灭火器登记  PUT  /cust/updateExtingusher
export function updateExtingusher(token, data) {
  return request({
    url: '/api/cust/updateExtingusher',
    method: 'PUT',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 更新防排烟系统   PUT  /cust/updateSmoke
export function updateSmoke(token, data) {
  return request({
    url: '/api/cust/updateSmoke',
    method: 'PUT',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 更新室外消防给水系统   PUT  /cust/updateFireWaterOut
export function updateFireWaterOut(token, data) {
  return request({
    url: '/api/cust/updateFireWaterOut',
    method: 'PUT',
    data
  })
}

// 更新自动灭火系统 PUT  /cust/updateAutoMaic
export function updateAutoMaic(token, data) {
  return request({
    url: '/api/cust/updateAutoMaic',
    method: 'PUT',
    data
  })
}

// 更新消防报警 PUT  /cust/updateFireAlarm
export function updateFireAlarm(token, data) {
  return request({
    url: '/api/cust/updateFireAlarm',
    method: 'PUT',
    data
  })
}

// 更新气体灭火  PUT  /cust/updateGasFire
export function updateGasFire(token, data) {
  return request({
    url: '/api/cust/updateGasFire',
    method: 'PUT',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 查询所有的消防水源   GET   /cust/findAllWater

export function findAllWater(token) {
  return request({
    url: '/api/cust/findAllWater',
    method: 'GET',
    data
  })
}

// 火灾配置场所类别 GET 73  /cust/findAllType
export function findAllType(token) {
  return request({
    url: '/api/cust/findAllType',
    method: 'GET',
    data
  })
}

// 删除产品 DELETE  /cust/deleteProduct productId 产品id
export function deleteProduct(token, id) {
  return request({
    url: '/api/cust/deleteProduct?productId=' + id,
    method: 'DELETE'
  })
}

export function updateDevName(token, devId, devName) {
  return request({
    url: `/api/smoking/updateDevName?devId=${devId}&devName=${devName}`,
    method: 'put'
  })
}

export function coupdateDevName(token, devId, devName) {
  return request({
    url: `/api/co/updateDevName?devId=${devId}&devName=${devName}`,
    method: 'put'
  })
}

// ============管理员查询待激活用户列表  GET  /member/queryAckUserList
export function queryAckUserList(token) {
  return request({
    url: `/api/member/queryAckUserList`,
    method: 'get'
  })
}

// /member/ackUser
export function ackUser(token, userId) {
  return request({
    url: `/api/member/ackUser?userId=${userId}`,
    method: 'PUT'
  })
}
// /cust/queryYqList
export function queryYqList(token) {
  return request({
    url: `/api/cust/queryYqList`,
    method: 'GET'
  })
}

// 查询所有的可用执守人员(下拉框)

export function queryAllGuardUser() {
  return request({
    method: 'get',
    url: '/api/cust/queryAllGuardUser'
  })
}

// cust/custInfo  查看单位信息列表
export function custInfo(custId) {
  return request({
    method: 'post',
    url: '/api/cust/custInfo?custId=' + custId
  })
}

// 新增设备台账
// /deviceLedger/add
export function deviceLedgerAdd(data) {
  return request({
    method: 'post',
    url: '/api/deviceLedger/add',
    data
  })
}

// 修改设备台账
// /deviceLedger/update

export function deviceLedgerUpdate(data) {
  return request({
    method: 'put',
    url: '/api/deviceLedger/update',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 根据id删除设备台账信息
// /deviceLedger/del?id=86ece6adddf2444f9817c82c0ece4d7b

export function deviceLedgerDel(id) {
  return request({
    method: 'DELETE',
    url: `/api/deviceLedger/del?id=${id}`
    // data: JSON.stringify({id})
  })
}

// 不同维度下的设备台账查询

// 说明一下searchType这个参数，目前主要分三个维度去查询设备台账信息，1 单位维度 2 建筑维度 3 消防系统维度
// searchType=1时，需要把单位id传过来,其它都不要
// searchType=2时，需要把单位id、建筑id传过来,其它都不要
// searchType=3时，需要把单位id、建筑id、消防系统id传过来,其它都不要
// 其它: 设备状态和设备名称这两个参数暂时保留，具体使用场景待定;返回数据是分页的，并且数据格式相同
// /deviceLedger/findDeviceLedgers?searchType=3&custId=517b22d0-026e-4199-a49e-dc6cc6aff2cd&buildingId=b5067077-6859-488c-bd8b-34b819d77573&fireSystemId=01&status=&deviceName=&pageNum=1&pageSize=15
export function deviceLedgerFindDeviceLedgers(argument) {
  return request({
    method: 'GET',
    url: '/api/deviceLedger/findDeviceLedgers',
    params: argument
  })
}

// 获取Excel导入模板
// /deviceLedger/excelTemplate
export function deviceLedgerFindExcelTemplate() {
  return request({
    method: 'post',
    url: '/api/deviceLedger/excelTemplate'
  })
}

// excel批量导入设备台账
// /deviceLedger/importExcel
export function deviceLedgerImportExcel() {
  return request({
    method: 'post',
    url: '/api/deviceLedger/importExcel'
  })
}

// 根据查询条件，导出excel
// /deviceLedger/exportExcel?searchType=3&custId=517b22d0-026e-4199-a49e-dc6cc6aff2cd&buildingId=b5067077-6859-488c-bd8b-34b819d77573&fireSystemId=01&status=&deviceName=
export function deviceLedgerExportExcel() {
  return request({
    method: 'post',
    url: '/api/deviceLedger/exportExcel'
  })
}

// 查询所有单位
 export function findAllCust() {
  return request({
    url: '/api/cust/findAllCust',
    method: 'GET'
  })
}

// 查询所有单位类型
export function queryAllCustTpye() {
  return request({
    url: '/api/cust/queryAllCustTpye',
    method: 'GET'
  })
}

// 查询所有省份
export function queryAllProvince() {
  return request({
    url: '/api/cust/queryAllProvince',
    method: 'GET'
  })
}

// 根据省份ID查询城市
export function queryCityByProvinceId(provinceId) {
  return request({
    url: '/api/cust/queryCityByProvinceId',
    method: 'GET',
    params: { provinceId }
  })
}

// 根据城市ID查询区域
export function queryAreaByCityId(cityId) {
  return request({
    url: '/api/cust/queryAreaByCityId',
    method: 'GET',
    params: { cityId }
  })
}

export function getIndustryTypes() {
  return request({
    url: '/api/dict/findValuesByCode',
    method: 'GET',
    params: {
      code: 'industry_type'
    }
  })
}
/**
 * 根据父区域编码查询街道级别区域信息
 * @param {string} pCode - 父区域编码
 * @returns {Promise} - 返回街道区域列表
 */
export function queryAreaNew(pCode, codeLevel) {
  return request({
    url: '/api/areaNew/findAll',
    method: 'GET',
    params: { codeLevel, pCode }
  })
}

export function queryStreetByAreaId(pCode) {
  return queryAreaNew(pCode, '3');
}

/**
 * 获取监管类别选项
 * @returns {Promise} - 返回监管类别选项列表
 */
export function getUnitTypeOptions() {
  return request({
    url: '/api/dict/findValuesByCode',
    method: 'GET',
    params: {
      code: 'unit_type'
    }
  });
}

/**
 * 获取单位类别选项
 * @returns {Promise} - 返回单位类别选项列表
 */
export function getOrgTypeOptions() {
  return request({
    url: '/api/dict/findValuesByCode',
    method: 'GET',
    params: {
      code: 'org_type_big'
    }
  });
}

/**
 * 获取消防主管部门选项
 * @returns {Promise} - 返回消防主管部门选项列表
 */
export function getFireManageIdOptions() {
  return request({
    url: '/api/dict/findValuesByCode',
    method: 'GET',
    params: {
      code: 'fire_manage_id'
    }
  });
}

/**
 * 获取监管等级选项
 * @returns {Promise} - 返回监管等级选项列表
 */
export function getMonitorLevelOptions() {
  return request({
    url: '/api/dict/findValuesByCode',
    method: 'GET',
    params: {
      code: 'monitor_level'
    }
  });
}

/**
 * 获取房屋结构选项
 * @returns {Promise} - 返回房屋结构选项列表
 */
export function getHouseStructureOptions() {
  return request({
    url: '/api/dict/findValuesByCode',
    method: 'GET',
    params: {
      code: 'house_structure'
    }
  });
}

// 查询所有管家
export function queryAllManger() {
  return request({
    url: '/api/cust/queryAllManger',
    method: 'GET'
  })
}

// 查询系统工号
export function querySystemWorkNumb() {
  return request({
    url: '/api/cust/querySystemWorkNumb',
    method: 'GET'
  })
}

// 创建单位
export function insertCustForWB(data) {
  return request({
    url: '/api/cust/insertCustForWB',
    method: 'POST',
    data
  })
}

// 更新单位信息
export function updateCust(data) {
  return request({
    url: '/api/cust/updateCust',
    method: 'PUT',
    data
  })
}

// 新增单位扩展信息
export function addCustBaseExtend(data) {
  return request({
    url: '/api/custBaseExtend/add',
    method: 'post',
    data
  })
}

// 更新单位扩展信息
export function updateCustBaseExtend(data) {
  return request({
    url: '/api/custBaseExtend/update',
    method: 'put',
    data
  })
}

// custBaseExtend/queryByCustId

export function updateCustQueryByCust(custId) {
  return request({
    url: '/api/custBaseExtend/queryByCustId',
    method: 'get',
       params: {
      custId 
    }
  })
}
